import React, { useState, useEffect, useMemo } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Footer, AppHeader, EnvironmentBadge, AppLauncher, StagingBanner, ThemeToggle, IconSprite } from '@weretradeit/ui-react';
import { launcherApps } from './config/launcher-apps';
import { useAuth } from '@weretradeit/hooks';
import './styles.css';

import { LogsPage } from './pages/LogsPage';
import { ApiPage } from './pages/ApiPage';
import { ResearchPage } from './pages/ResearchPage';
import { AndminerPage } from './pages/AndminerPage';
import { ProjectMapPage } from './pages/ProjectMapPage';
import { SettingsPage } from './pages/SettingsPage';

interface ConfigWindow extends Window {
  MAIN_DOMAIN?: string;
}

const MAIN_DOMAIN = (window as ConfigWindow).MAIN_DOMAIN || 'weretrade.com';

function Dashboard() {
  useEffect(() => {
    window.location.replace('https://webos.weretrade.com/');
  }, []);

  return (
    <main className="app-main" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '50vh' }}>
      <div style={{ textAlign: 'center' }}>
        <h1 className="text-shimmer">Redirecting...</h1>
        <p className="header-subtitle">You are being redirected to Puter Desktop.</p>
      </div>
    </main>
  );
}

function App() {
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="app-shell">
        <div className="overlay">
          <div className="overlay-box">
            <div className="spinner big" />
            <div className="label">Verifying Session...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="app-shell">
        <div className="overlay">
          <div className="overlay-box">
            <div className="spinner big" />
            <div className="label">Redirecting to Login...</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <StagingBanner />
      <div className="app-shell app-layout">
        {/* Der Sprite MUSS im Dokument stehen: <Icon> loest ueber
            <use href="#i-…"> auf, und der Launcher-Knopf selbst rendert ein
            Icon. Ohne ihn ist der Knopf leer — ohne Fehler in der Konsole. */}
        <IconSprite src="/icons/sprite.svg" />

        <AppHeader
          appName="serviceAnt"
          orgName="weretradeIT"
          mark="serviceAnt"
          actions={
            <>
              <AppLauncher apps={launcherApps} current="services" />
              <EnvironmentBadge hideInProduction={true} />
              <ThemeToggle />
              {/* 0.6.x erzeugte diese Halterung ueber showUserWidget; 3.x kennt
                  die Eigenschaft nicht. Ohne die Zeile faende
                  /assets/user-widget.js seinen Ankerpunkt nicht — und das
                  Widget verschwaende, ohne dass etwas bricht. */}
              <div id="wt-user-widget-mount" />
            </>
          }
        />

        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/logs" element={<LogsPage />} />
          <Route path="/api" element={<ApiPage />} />
          <Route path="/research" element={<ResearchPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/andminer" element={<AndminerPage />} />
          <Route path="/projectmap" element={<ProjectMapPage />} />
        </Routes>

        <Footer />
      </div>
    </>
  );
}
export default App;
